import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraFilterToolbar } from '../captains/filter-toolbar';
/** Two-pane review layout for modifications, audits, and entity registries. */ export const SpecraMasterDetail = /*#__PURE__*/ React.forwardRef(({ className, detail, detailLabel = 'Details', master, masterLabel = 'Records', toolbar, ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: cn('flex h-full min-h-0 flex-col', className),
        ref: ref,
        ...props,
        children: [
            toolbar ? /*#__PURE__*/ _jsx(SpecraFilterToolbar, {
                className: "shrink-0 p-3 sm:p-4",
                ...toolbar
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: "grid min-h-0 flex-1 grid-rows-[minmax(var(--component-master-list-min-height),0.45fr)_minmax(var(--component-master-detail-min-height),1fr)] md:grid-cols-[minmax(var(--component-master-list-min-width),0.4fr)_minmax(0,1fr)] md:grid-rows-1",
                children: [
                    /*#__PURE__*/ _jsx("section", {
                        "aria-label": masterLabel,
                        className: "min-h-0 overflow-y-auto border-b border-border md:border-b-0 md:border-r",
                        children: master
                    }),
                    /*#__PURE__*/ _jsx("section", {
                        "aria-label": detailLabel,
                        className: "min-h-0 overflow-y-auto",
                        children: detail
                    })
                ]
            })
        ]
    }));
SpecraMasterDetail.displayName = 'SpecraMasterDetail';
